import { useEffect } from "react"
import { Link } from "react-router-dom"
import { Container, FullRow, Title } from "../../components"
import { ClockCircleOutlined, MailOutlined, InfoCircleOutlined } from "@ant-design/icons"
import { useTheme } from "styled-components"

export function ActivationExpired(): JSX.Element {
    const theme = useTheme()

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0)
    }, [])

    return (
        <Container style={{ marginTop: "3.5em", textAlign: "center" }}>
            <FullRow>
                <div style={{ 
                    display: "flex", 
                    flexDirection: "column", 
                    alignItems: "center", 
                    gap: "1.5rem",
                    maxWidth: "600px",
                    margin: "0 auto",
                    padding: "2rem",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "12px",
                    border: "1px solid #e0e0e0"
                }}>
                    <ClockCircleOutlined 
                        style={{ 
                            fontSize: "4rem", 
                            color: "#fa8c16" 
                        }} 
                    />
                    
                    <Title style={{ 
                        color: "#fa8c16", 
                        marginBottom: 0,
                        fontSize: "2rem"
                    }}>
                        Activation Link Expired
                    </Title>
                    
                    <p style={{ 
                        fontSize: "1.1rem", 
                        color: "#666", 
                        lineHeight: "1.6",
                        margin: "0 0 1rem 0"
                    }}>
                        Sorry, your account activation link has expired.
                    </p>
                    
                    <div style={{
                        backgroundColor: "#fff7e6",
                        border: "1px solid #ffd591",
                        borderRadius: "8px",
                        padding: "1.5rem",
                        width: "100%",
                        textAlign: "left"
                    }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1rem" }}>
                            <InfoCircleOutlined style={{ color: "#fa8c16", fontSize: "1.2rem" }} />
                            <h3 style={{ margin: 0, color: "#fa8c16" }}>What happened?</h3>
                        </div>
                        <p style={{ margin: "0 0 1rem 0", color: "#333" }}>
                            Activation links expire after 24 hours for security reasons. Your link is no longer valid.
                        </p>
                    </div>
                    
                    <div style={{
                        backgroundColor: "#e6f7ff",
                        border: "1px solid #91d5ff",
                        borderRadius: "8px",
                        padding: "1.5rem",
                        width: "100%",
                        textAlign: "left"
                    }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1rem" }}>
                            <MailOutlined style={{ color: theme.primary, fontSize: "1.2rem" }} />
                            <h3 style={{ margin: 0, color: theme.primary }}>What can I do?</h3>
                        </div>
                        <p style={{ margin: "0 0 1rem 0", color: "#333" }}>
                            You'll need to register again to get a new activation email. Don't worry - if an account already exists with your email, the system will handle it appropriately.
                        </p>
                    </div>
                    
                    <div style={{ 
                        display: "flex", 
                        gap: "1rem", 
                        marginTop: "1rem",
                        flexWrap: "wrap",
                        justifyContent: "center"
                    }}>
                        <Link 
                            to="/register" 
                            style={{ 
                                backgroundColor: theme.primary,
                                color: "white",
                                padding: "0.75rem 1.5rem",
                                borderRadius: "6px",
                                textDecoration: "none",
                                fontWeight: "500",
                                border: "none",
                                cursor: "pointer",
                                transition: "background-color 0.2s"
                            }}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#1890ff"}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = theme.primary}
                        >
                            Register Again
                        </Link>
                        
                        <Link 
                            to="/" 
                            style={{ 
                                backgroundColor: "transparent",
                                color: theme.primary,
                                padding: "0.75rem 1.5rem",
                                borderRadius: "6px",
                                textDecoration: "none",
                                fontWeight: "500",
                                border: `1px solid ${theme.primary}`,
                                cursor: "pointer",
                                transition: "all 0.2s"
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor = theme.primary
                                e.currentTarget.style.color = "white"
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor = "transparent"
                                e.currentTarget.style.color = theme.primary
                            }}
                        >
                            Return to Home
                        </Link>
                    </div>
                </div>
            </FullRow>
        </Container>
    )
}
